module.exports = __webpack_public_path__ + "img/883ac41.jpeg";